/**
 * Charge /assets/config.json au demarrage et fusionne les cles dans environment.
 * Permet une image unique par front, configuree au runtime (domaines migrate.*).
 *
 * Les services de `shared/` importent `projects/environments/environment` (celui
 * que `fileReplacements` remplace au build). Plusieurs `main.ts` importaient
 * encore le chemin app-local `./environments/environment` : un autre objet, donc
 * le runtime config n'atteignait jamais les appels HTTP → l'API de prod restait
 * sollicitee depuis migrate.*. On ecrit donc toujours sur le module shared.
 */
import { environment as sharedEnvironment } from '../../../environments/environment';

function applyConfig(target: Record<string, any>, config: Record<string, any>): void {
  const cfg: Record<string, any> = { ...config };
  if (cfg.urls && target.urls) {
    target.urls = { ...target.urls, ...cfg.urls };
    delete cfg.urls;
  }
  Object.assign(target, cfg);
}

export async function loadRuntimeConfig(environment: Record<string, any>): Promise<void> {
  try {
    const response = await fetch('/assets/config.json', { cache: 'no-store' });
    if (!response.ok) {
      return;
    }
    const config = await response.json();
    if (!config || typeof config !== 'object') {
      return;
    }
    applyConfig(environment, config);
    if (environment !== (sharedEnvironment as unknown as Record<string, any>)) {
      applyConfig(sharedEnvironment as unknown as Record<string, any>, config);
    }
  } catch {
    // Fichier absent en local : on conserve environment.ts / environment.prod.ts
  }
}
